import { render, staticRenderFns } from "./PushDistribution.vue?vue&type=template&id=6e5f7f6c&"
import script from "./PushDistribution.vue?vue&type=script&lang=ts&"
export * from "./PushDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports